import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'sushiweb/Button';
import grey from 'sushiweb/tokens/color/grey';
import H5 from 'sushiweb/Typography/Heading/H5';
import { P } from 'sushiweb/Typography/Text';
import Download from 'sushiweb/Icons/all/Download';
import { FormWrapper } from '../../../Onboarding/components/styles';

const StyledP = styled(P)`
  font-size: 1.4rem;
  margin-top: -1.1rem;
  margin-bottom: 1.7rem;
  color: ${grey.z700};
`;

const DownloadComponent = ({ title, label, link }) => {
  return (
    <FormWrapper>
      <H5>{title}</H5>
      <StyledP>{label}</StyledP>
      {link ? (
        <a href={link} target='_blank' rel='noreferrer'>
          <Button btnColor='red' iconAlign='left' icon={<Download />}>
            Download
          </Button>
        </a>
      ) : null}
    </FormWrapper>
  );
};

DownloadComponent.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  link: PropTypes.string,
};

DownloadComponent.defaultProps = {
  title: '',
  label: '',
  link: '',
};

export default DownloadComponent;
